import { render } from "./EmbeddedApp.vue?vue&type=template&id=301990ec&scoped=true"
import script from "./EmbeddedApp.vue?vue&type=script&lang=js"
export * from "./EmbeddedApp.vue?vue&type=script&lang=js"

import "./EmbeddedApp.vue?vue&type=style&index=0&id=301990ec&scoped=true&lang=css"

import exportComponent from "../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301990ec"]])

export default __exports__